import { PageDescription } from '@/shared/components';
import LocalMachineRequests from './components/LocalmachineRequests/LocalmachineRequests';

function LocalmachineRequestsPage() {
  return (
    <div className='usersPageWrapper'>
      <PageDescription title={'Локальные сервера'} />
      <LocalMachineRequests />
    </div>
  );
}

export default LocalmachineRequestsPage;
